
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetopandharpurcab() {



    const cardData =
    {
        keyword: 'Pune to Pandharpur Cab',
        heading: 'Meghana Cab : Pune to Pandharpur Cab',
        headingDescription: 'Meghana Cab offers Pune to Pandharpur Cab services, providing a comfortable and devotional journey to the revered temple town of Lord Vitthal. Whether you’re visiting for pilgrimage, festivals, or a spiritual retreat, our clean and well-maintained cabs with courteous drivers ensure a safe and peaceful ride. Benefit from affordable pricing, flexible booking options, and 24/7 support. Book your Pune to Pandharpur Cab with Meghana Cab for a smooth, timely, and spiritually fulfilling travel experience.',


        top: 'Top Places to Visit in Pandharpur with Meghana Cab',

"topPlaces": [
  {
    "title": "Vitthal Rukmini Temple",
    "description": "The most prominent spiritual destination in Pandharpur, this temple is dedicated to Lord Vitthal (a form of Krishna) and his consort Rukmini. Pilgrims from across Maharashtra and India visit the temple, especially during Ashadhi and Kartiki Ekadashi yatras. The darshan of the black stone idol, standing on a brick, is deeply symbolic and spiritually significant."
  },
  {
    "title": "Chandrabhaga River Ghat",
    "description": "The holy river Chandrabhaga, also known as Bhima, forms a crescent-shaped curve around Pandharpur. Pilgrims take ritual baths at the ghat before visiting the temple. The riverside area is known for its spiritual ambiance, devotional singing, and religious offerings."
  },
  {
    "title": "Pundalik Temple",
    "description": "Dedicated to Pundalik, the devoted son whose legend is associated with the origin of Vitthal's presence in Pandharpur. The temple honors his deep devotion and is located near the Chandrabhaga riverbank. It is a key part of the pilgrimage circuit."
  },
  {
    "title": "Kaikadi Maharaj Math",
    "description": "An ashram and spiritual center that also serves as a mini-museum. It showcases stories and life-size dioramas from Hindu scriptures like the Ramayana and Mahabharata. The displays are educational and visually engaging for all age groups."
  },
  {
    "title": "Sant Namdev Step (Namdev Payari)",
    "description": "These sacred steps at the entrance of the Vitthal temple are named after the saint Namdev. According to legend, Vitthal himself asked Namdev to enter through the back door in humility. Pilgrims touch and bow to these steps as a mark of respect."
  },
  {
    "title": "Sant Dnyaneshwar Temple",
    "description": "Located near the Vitthal temple, this shrine is dedicated to Sant Dnyaneshwar, a revered Marathi saint and poet. The site is associated with his devotion and contributions to the Bhakti movement. Devotees often visit after darshan at the main temple."
  },
  {
    "title": "ISKCON Pandharpur",
    "description": "A modern spiritual center maintained by the ISKCON foundation. The temple complex includes beautiful deities of Krishna and Radha, a serene meditation hall, and a cultural complex. It attracts both pilgrims and international visitors."
  },
  {
    "title": "Tapovan Forest",
    "description": "Located a few kilometers from Pandharpur, this peaceful forest area is associated with various saints and their spiritual practices. It is an ideal spot for meditation, nature walks, and spiritual retreats."
  },
  {
    "title": "Gopalpur Forest Ashram",
    "description": "A tranquil ashram located on the outskirts of Pandharpur, offering spiritual discourses, yoga sessions, and accommodation for pilgrims. It is especially popular during festival periods when the town is crowded."
  },
  {
    "title": "Vithoba Museum",
    "description": "A cultural museum that depicts the life and times of Sant Tukaram, Namdev, Dnyaneshwar, and other Varkari saints. It includes artifacts, photographs, and audio-visual presentations that help visitors understand the cultural and spiritual legacy of Pandharpur."
  }
],

"services": [
    {
        "name": "Pune to Pandharpur Temple Cab",
        "description": "Travel comfortably from Pune to Pandharpur Temple with Meghana Cab’s reliable and safe taxi service. Ideal for pilgrimage and spiritual journeys, our cabs offer a peaceful and hassle-free ride."
    },
    {
        "name": "Book Taxi Pune to Pandharpur",
        "description": "Easily book a taxi from Pune to Pandharpur online with Meghana Cab. Enjoy quick booking, professional drivers, and timely pickups for a smooth travel experience to the holy city."
    },
    {
        "name": "One Way Cab to Pandharpur from Pune",
        "description": "Opt for an affordable and convenient one-way cab service from Pune to Pandharpur. Perfect for solo travelers and pilgrims who prefer flexible travel plans without return trip obligations."
    },
    {
        "name": "Round Trip Pune to Pandharpur Taxi",
        "description": "Plan your round trip from Pune to Pandharpur with Meghana Cab. Our round trip taxi service ensures comfort, safety, and on-time service for your entire pilgrimage journey."
    },
    {
        "name": "AC Cab Pune to Pandharpur Trip",
        "description": "Travel in comfort with air-conditioned taxis from Pune to Pandharpur. Meghana Cab offers well-maintained AC vehicles to make your pilgrimage trip pleasant even in hot weather."
    },
    {
        "name": "Affordable Cabs to Pandharpur",
        "description": "Get the best budget-friendly cab options from Pune to Pandharpur without compromising on service quality. Meghana Cab provides competitive fares and transparent pricing."
    },
    {
        "name": "Pilgrimage Cab Pune to Pandharpur",
        "description": "Make your religious trip special with Meghana Cab’s dedicated pilgrimage taxi service. Our drivers are experienced in routes to Pandharpur and offer a respectful and calm travel environment."
    },
    {
        "name": "Private Car Hire to Pandharpur from Pune",
        "description": "Hire a private car for your trip from Pune to Pandharpur with Meghana Cab. Enjoy exclusive use of the vehicle, personalized schedules, and privacy throughout your spiritual journey."
    },
    {
        "name": "Pune to Pandharpur Driver Cab",
        "description": "Travel safely with professional chauffeur-driven taxis from Pune to Pandharpur. Our skilled drivers ensure a smooth, comfortable ride and punctual service."
    },
    {
        "name": "Sedan & SUV Pune to Pandharpur",
        "description": "Choose from a wide range of sedans and SUVs for your Pune to Pandharpur trip based on your group size and comfort preferences. Meghana Cab ensures quality vehicles and excellent service."
    },
    {
        "name": "Book Outstation Cab for Pandharpur",
        "description": "Conveniently book outstation taxis for your Pandharpur trip from Pune. Meghana Cab offers reliable vehicles suitable for long-distance travel with all necessary amenities."
    },
    {
        "name": "Pune to Pandharpur Road Travel",
        "description": "Experience smooth and scenic road travel from Pune to Pandharpur with Meghana Cab. Our taxis follow the safest and fastest routes ensuring timely arrivals and enjoyable journeys."
    },
    {
        "name": "Fast Cab Pune to Pandharpur",
        "description": "Need a quick and efficient taxi to Pandharpur from Pune? Meghana Cab provides fast booking and timely cab arrivals to ensure you reach your destination on schedule."
    },
    {
        "name": "Religious Tour Cab Pune to Pandharpur",
        "description": "Enhance your religious tour experience with Meghana Cab’s specialized cab services. Our vehicles are comfortable and well-equipped for pilgrim groups traveling to Pandharpur."
    },
    {
        "name": "24/7 Taxi to Pandharpur from Pune",
        "description": "Avail 24/7 taxi service from Pune to Pandharpur with Meghana Cab. Whether it’s an early morning or late night journey, our taxis are available around the clock to serve your needs."
    }
],

"tableData": [
    ["Pune to Pandharpur Temple Cab", "Book Taxi Pune to Pandharpur"],
    ["One Way Cab to Pandharpur from Pune", "Round Trip Pune to Pandharpur Taxi"],
    ["AC Cab Pune to Pandharpur Trip", "Affordable Cabs to Pandharpur"],
    ["Pilgrimage Cab Pune to Pandharpur", "Private Car Hire to Pandharpur from Pune"],
    ["Pune to Pandharpur Driver Cab", "Sedan & SUV Pune to Pandharpur"],
    ["Book Outstation Cab for Pandharpur", "Pune to Pandharpur Road Travel"],
    ["Fast Cab Pune to Pandharpur", "Religious Tour Cab Pune to Pandharpur"],
    ["24/7 Taxi to Pandharpur from Pune", ""],
    ["", ""]
],











"whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Pandharpur Cab Service",
        "WhyChoosedescription": "Meghana Cab offers comfortable and dependable cab services from Pune to Pandharpur, perfect for pilgrims, tourists, and business travelers seeking hassle-free transportation."
    },
    {
        "WhyChooseheading": "Experienced Drivers Familiar with the Route",
        "WhyChoosedescription": "Our professional drivers know the Pune to Pandharpur route well, ensuring a safe and timely journey with smooth navigation through all terrains."
    },
    {
        "WhyChooseheading": "Flexible Pickup and Drop-off Locations",
        "WhyChoosedescription": "We provide convenient pick-up and drop-off options from your preferred locations in Pune to anywhere in Pandharpur, tailored to your travel plans."
    },
    {
        "WhyChooseheading": "Clean and Comfortable Vehicles",
        "WhyChoosedescription": "Travel in sanitized, air-conditioned vehicles that are regularly maintained for your comfort and safety during the trip."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Our Pune to Pandharpur cab service offers competitive rates with no hidden charges, helping you plan your budget with ease."
    },
    {
        "WhyChooseheading": "Customizable Itineraries and Stopovers",
        "WhyChoosedescription": "Want to visit other places along the way? We offer customizable travel plans and stopovers to enhance your journey experience."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Our cab services operate round-the-clock, so you can book your Pune to Pandharpur cab anytime, including late-night or early-morning departures."
    },
    {
        "WhyChooseheading": "Easy and Quick Booking Process",
        "WhyChoosedescription": "Book your cab easily via our website, app, or customer service. Enjoy prompt confirmations and reliable support throughout your trip."
    }
]


































    }

const faqData = [
    {
        question: "How can I book a cab from Pune to Pandharpur with Meghana Cab?",
        answer: "You can easily book a Pune to Pandharpur cab by calling Meghana Cab at +91 9075462128 or through our website."
    },
    {
        question: "What types of vehicles are available for Pune to Pandharpur trips?",
        answer: "We offer sedans, SUVs, and tempo travellers suitable for your comfort during the journey to Pandharpur."
    },
    {
        question: "Are your drivers experienced with routes to Pandharpur?",
        answer: "Yes, our drivers are familiar with the best routes to Pandharpur to ensure a safe and smooth trip."
    },
    {
        question: "Can I book a one-way or round trip cab from Pune to Pandharpur?",
        answer: "Yes, Meghana Cab provides both one-way and round-trip cab services to Pandharpur based on your needs."
    },
    {
        question: "What is included in the Pune to Pandharpur cab fare?",
        answer: "The fare includes driver charges, vehicle maintenance, and fuel. Additional costs such as tolls and parking may apply."
    },
    {
        question: "Is Meghana Cab available 24/7 for Pune to Pandharpur bookings?",
        answer: "Yes, our services operate round-the-clock to assist with your Pune to Pandharpur cab bookings."
    },
    {
        question: "Can I hire a cab for a group traveling to Pandharpur?",
        answer: "Yes, we offer a range of vehicle options including tempo travellers for larger groups."
    },
    {
        question: "Are the vehicles clean and sanitized for travel?",
        answer: "All our vehicles are regularly cleaned and sanitized to ensure your safety and comfort."
    },
    {
        question: "What payment methods do you accept for Pune to Pandharpur cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments for your convenience."
    },
    {
        question: "How can I contact Meghana Cab for Pune to Pandharpur cab service?",
        answer: "Call Meghana Cab at +91 9075462128 for bookings or inquiries about Pune to Pandharpur cab services."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Sameer Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Meghana Cab made our Pune to Pandharpur trip comfortable and hassle-free. The driver was professional and the vehicle well-maintained.”',
    },
    {
        name: 'Mrs. Priya Joshi',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Highly recommend Meghana Cab for Pune to Pandharpur travel. Timely service and excellent vehicle condition.”',
    },
];



























































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Pandharpur Cab",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-pandharpur-cab.jpg",
  "description": "Book Pune to Pandharpur cab services with Meghana Cabs for comfortable, affordable, and reliable travel. Suitable for pilgrimage, round trips, AC sedans, SUVs, and private hires.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2800",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-pandharpur-cab"
  }
};





    return (
        <div>

<Helmet>
  <title>Pune to Pandharpur Cab | Affordable Pilgrimage Taxi | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Pandharpur cab services with Meghana Cabs for comfortable, affordable, and reliable travel. Suitable for pilgrimage, round trips, AC sedans, SUVs, and private hires." 
  />
  <meta 
    name="keywords" 
    content="Pune to Pandharpur Temple Cab, Book Taxi Pune to Pandharpur, One Way Cab to Pandharpur from Pune, Round Trip Pune to Pandharpur Taxi, AC Cab Pune to Pandharpur Trip, Affordable Cabs to Pandharpur, Pilgrimage Cab Pune to Pandharpur, Private Car Hire to Pandharpur from Pune, Pune to Pandharpur Driver Cab, Sedan & SUV Pune to Pandharpur, Book Outstation Cab for Pandharpur, Pune to Pandharpur Road Travel, Fast Cab Pune to Pandharpur, Religious Tour Cab Pune to Pandharpur, 24/7 Taxi to Pandharpur from Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/23.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetopandharpurcab;